import React from "react"

export const Vectors = () => {
  return (
    <svg width="1601" height="904" viewBox="0 0 1601 904" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g><path d="M79.6455 903.621L334.368 0.700684H0.177734L0.177814 903.621H79.6455Z" fill="currentcolor" /></g>
      <g data-swiper-parallax={'20%'}><path opacity="0.5" d="M984.903 117.607L0.177734 415.701L0.17771 0.700809L1013.61 0.700775L984.903 117.607Z" fill="currentcolor" /></g>
    </svg>
  )
}